import React from 'react';
import styles from './Authentication.module.css';
import Avatar from '../Avatar/Avatar.js';
import LogIn from '../LogIn/LogIn.js';
import { userLogin } from '../../services/api.js';

function Authentication() {
  const isAuthenticated = !!localStorage.getItem('user_id');

  const handleLogIn = async () => {
    const response = await userLogin()
    if (response.data.redirect_url) {
      window.location.href = response.data.redirect_url;
      return null;
    } else if (response.data.user) {
      console.log("Dispatch retrieving profile / information")
    } else {
      console.log("Throw an error")
    }
  };

  return (
    <div className={styles.layout}>
      {isAuthenticated ? (
        <Avatar />
      ) : (
        <LogIn handleLogIn={handleLogIn} />
      )}
    </div>
  );
}

export default Authentication;